module.exports = __webpack_public_path__ + "img/blomkaal_avo.7284b159.jpg";